import axios from "./axios_client";

/**
 * Categories Request
 */
export const getCategories = () => axios.get("/indexes");

/**
 * Get Land Degradation
 */
export const getLandDegradation = async (formData) => {
  return axios.post("/land-degradation", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

/**
 * indexes requests
 */
export const addIndex = (params) => axios.post("indexes", params);

export const getIndexData = (params) =>
  axios.post(`/vegetation/ndvi/${params.request_type}`, params);

export const getNDVI = (params) => axios.post("/vegetation/ndvi", params);

//Evapotranspiration
export const getETA = (params) => axios.post("/vegetation/eta", params);

// precipitation
export const getPrecipitation = (params) =>
  axios.post("/weather/Precipitation", params);

// Perciptation Monthly Monitoring
export const getPercipitationMonthly = (params) =>
  axios.post("/weather/Precipitation-monthly", params);

//vci
export const getVCI = (params) => axios.post("/drought/vci", params);
//VHI
export const getVHI = (params) => axios.post("/drought/vhi", params);

//ASI
export const getASI = (params) => axios.post("/drought/asi", params);

//land cover
export const getLandCover = (params) => axios.post("/land_cover", params);
//SPI
export const getSPI = (params) => axios.post("/drought/spi", params);

/**
 * User Auth Autherize methods
 */

export const loginUser = (params) => axios.post("/user/login", params);
export const registerUser = (params) => axios.post("/user/register", params);
// Send password reset email
export const resetEmail = (params) =>
  axios.post("/user/reset-password-email", params);

// Submit new password (PUT)
export const updatePassword = (params) =>
  axios.put(`/user/resetpassword/${params.token}`, { password: params.password });

// Activate account
export const activateAccount = (token) =>
  axios.get(`/user/activate/${token}`);

// Resend activation email
export const resendActivation = (params) =>
  axios.post("/user/resend-activation", params);
export const verifyEmail = (params) => axios.post("/user/verify", params);
export const logout = (params) => axios.post("/user/logout", params);
export const updateUserProfile = (params) =>
  axios.put(`/users/${params.userId}`, params);
